import { render, staticRenderFns } from "./SectionsHeader.vue?vue&type=template&id=bb2ec13a&scoped=true&"
import script from "./SectionsHeader.vue?vue&type=script&lang=js&"
export * from "./SectionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SectionsHeader.vue?vue&type=style&index=0&id=bb2ec13a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2ec13a",
  null
  
)

export default component.exports